import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const formatCurrency = (n) => n != null ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n) : '—';

export default function ReimbursementEstimator({ estimate }) {
  if (!estimate) return null;
  const {
    claimedAmount,
    deductibleAmount = 0,
    coPaymentAmount = 0,
    estimatedReimbursement,
    remainingLimit,
    limitExceeded
  } = estimate;

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>Reimbursement estimate</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="body2">Claimed amount: {formatCurrency(claimedAmount)}</Typography>
        <Typography variant="body2">Deductible: {formatCurrency(deductibleAmount)}</Typography>
        <Typography variant="body2">Co-payment: {formatCurrency(coPaymentAmount)}</Typography>
        <Box sx={{ borderTop: 1, borderColor: 'divider', pt: 1, mt: 0.5 }}>
          <Typography variant="body1" fontWeight="bold">Estimated payout: {formatCurrency(estimatedReimbursement)}</Typography>
        </Box>
        {remainingLimit != null && (
          <Typography variant="caption" color="textSecondary">
            Remaining limit after approval: {formatCurrency(remainingLimit)}
            {limitExceeded && ' (claim may exceed limit)'}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
